import { defineStore } from "pinia";
import { UserService } from "../services/user-service";
import { UserResponse } from "../models/user-response";

export const useUserStore = defineStore("user", {
  state: (): UserResponse => ({
    id: "",
    default_organization_id: "",
    unique_name: "",
    email: "",
    email_public: false,
    name: "",
    name_public: false,
    picture: "",
    subject_id: "",
    status: undefined,
    requiredAction: "",
    remainingDays: 0,
    features: [],
  }),

  getters: {
    getUserInfo: (state: UserResponse) => state,
  },

  actions: {
    initUserData(payload: UserResponse) {
      this.$state = payload;
    },
    $reset() {
      this.id = "";
      this.default_organization_id = "";
      this.unique_name = "";
      this.email = "";
      this.email_public = false;
      this.name = "";
      this.name_public = false;
      this.picture = "";
      this.subject_id = "";
      this.status = undefined;
    },
    resetUserData() {
      this.$reset();
    },
    async updateUserInfo() {
      try {
        const data = await UserService.fetchCurrentUser();
        this.initUserData(data);
      } catch (error) {
        const isTimeout = this.isTimeoutError(error);
        if (isTimeout) {
          setTimeout(async () => {
            try {
              const data = await UserService.fetchCurrentUser();
              this.initUserData(data);
            } catch (retryError) {
              throw new Error("Error updating user info after retry:" + error);
              // TODO handle properly error handling, log out? #893
            }
          }, 30000);
        } else {
          throw new Error("Error updating user info:" + error);
          // TODO handle properly error handling, log out? #893
        }
      }
    },
    isTimeoutError(error: unknown): boolean {
      const err = error as { code?: string; message?: string };
      return err?.code === "ECONNABORTED" || err?.message?.includes("timeout");
    },
  },
});
